export default __webpack_public_path__ + "static/media/white bottle.91e9c515.jpeg";